module.exports = __webpack_public_path__ + "static/media/shanghai-8-cssAni.a97821c6.gif";